import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';
import { MoneyValueDto } from '@/types/MoneyValueDto.ts';
import MoneyAmountList from '@/features/dashboard/bookingChanges/components/primitives/MoneyAmountList.tsx';

export type PersonTileAmountSize = 'md' | 'lg';

const amountVariants = cva('whitespace-nowrap tabular-nums', {
  variants: {
    size: {
      md: 'text-[15px] font-semibold',
      lg: 'text-[17px] font-bold',
    },
    muted: {
      true: 'text-neutral-500',
      false: 'text-ink',
    },
  },
  defaultVariants: {
    size: 'md',
    muted: false,
  },
});

const noteVariants = cva('whitespace-nowrap text-xs', {
  variants: {
    muted: {
      true: 'text-neutral-400',
      false: 'text-neutral-500',
    },
  },
  defaultVariants: {
    muted: false,
  },
});

interface PersonTileAmountProps extends React.HTMLAttributes<HTMLDivElement> {
  amount: MoneyValueDto[];
  /** Druga linia: „1800 → 1960 zł” w edycji, „rachunek uczestnika” w podglądzie. */
  note: string;
  /** Edycja pokazuje deltę szkicu, więc kwota potrzebuje znaku. */
  signed?: boolean;
  /** Kwota bez znaczenia w tym trybie — zapisujący nie ma wpływu na cenę. */
  muted?: boolean;
  size?: PersonTileAmountSize;
}

/**
 * Obie linie mają `whitespace-nowrap`: niosą liczby sklejone spacjami
 * („3 200 zł”, „1800 → 1960 zł”), które przeglądarka inaczej łamie w pół.
 */
const PersonTileAmount = ({
  amount,
  note,
  signed = false,
  muted = false,
  size = 'md',
  className,
  ...props
}: PersonTileAmountProps) => (
  <div className={cn('text-right', className)} {...props}>
    <div className={amountVariants({ size, muted })}>
      <MoneyAmountList values={amount} variant={signed ? 'signed' : 'plain'} />
    </div>
    <div className={noteVariants({ muted })}>{note}</div>
  </div>
);

export default PersonTileAmount;
